// User
export const HOMEPAGE = "/";
export const BLOG = "/blog/";
export const SEARCH = "/transactions";
export const TRANSACTION = "/transactions/:referenceID";
export const ERROR404 = "/404";
export const SUCCESS = "/success";
export const CONVERTER = "/converter";
export const SELL = "/sell";
export const SELL_COIN = "/sell/:coin";
export const SELL_COIN_REFERENCE = "/sell/:refID";

// Auth
export const LOGIN = "/login";
export const FORGOT_PASSWORD = "/forgot-password";
export const REGISTER = "/register";


// Dashboard Routes
export const DASHBOARD = "/dashboard";
export const PROFILE = DASHBOARD + "/user-profile";
export const VERIFY_EMAIL = DASHBOARD + "/confirm-email";
export const TRANSACTIONS = DASHBOARD + "/transactions";
export const TRANSACTION_FILTER = DASHBOARD + "/transactions/:sort";
export const REFERRALS = DASHBOARD + "/referrals";
export const BENEFICIARIES = DASHBOARD + "/beneficiaries";
